import React from "react";
import "./index.scss";
import { Col, Row } from "antd";
import Testimonials from "../../components/Testimonials";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="aboutus-main">
      {/* Banner */}
      <div id="banner-area">
        <div className="about-overlay"></div>
        <div className="banner-title-content">
          <h2>About Us</h2>
        </div>
      </div>

      {/* Main */}
        <div className="about-company-main">
          <h2 className="header">About Our Company</h2>
          <div className="sub-header">
            An experienced team of professionals with 20 years of Experience in
            IT Staffing
          </div>
        </div>

        <div className="container-fluid">
          {/* Section 1 */}
          <Row className="whoweare-main">
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
              className="whoweare-innertext-container"
            >
              <div className="whoweare-innertext">
                <h3 className="whoweare-header">WHO WE ARE</h3>

                <ul className="whoweare-header-list">
                  <li>
                    CDC is a collaboration of Computer, Data & Concepts with
                    over 20 years of experience in IT Staffing industry.
                  </li>
                  <li>
                    We provide Computer Personnels, Services & Various Concepts
                    in Information Technology and beyond.
                  </li>
                  <li>
                    We focus on Optimization in Hiring, Delivery of Candidates,
                    Profit Maximization & Customer Satisfaction.
                  </li>
                  <li>CDC is incorporated in the state of New Jersey.</li>
                  <li>
                    CDC specializes in IT Staffing and Non IT Consulting
                    services.
                  </li>
                  <li>
                    We offer Talent Acquisition Services across all verticals.
                  </li>
                  <li>CDC is a place of Multiple People & Possibilities.</li>
                  <li>
                    We simplify talent search and hiring process till final
                    delivery.
                  </li>
                </ul>
              </div>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
              <div className="whoweare-img whoweare-img1"></div>
            </Col>
          </Row>
          {/* Section 2 */}
          <Row className="whoweare-main">
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
              <div className="whoweare-img whoweare-img2"></div>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
               className="whoweare-innertext-container"
            >
              <div className="whoweare-innertext">
                <ul className="whoweare-header-list">
                  <li>
                    We focus on building Trust and Partnership with customers.
                  </li>
                  <li>
                    Expertise across Consulting, Data, Design, Cloud, AI &
                    Engineering.
                  </li>
                  <li>Customized end-to-end Talent Acquisition solutions.</li>
                  <li>
                    We turn ordinary delivery into extraordinary experience.
                  </li>
                  <li>We adapt to client needs and deliver best solutions.</li>
                  <li>We are passionate about People & Possibilities.</li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>

        {/* CTA */}

        <h4 className="quote">
          If you want to know more about us,&nbsp;
          <span>
          <Link to="/contact">
          contact us
          </Link>
          </span>&nbsp;
           & we will tell you more about our
          passion and capabilities.
        </h4>

        <Testimonials/>
     
    </div>
  );
};

export default About;
